var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(0 === _vm.activeStep ? 'Cancel' : 'Back')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }